  <ion-list class="ion-no-margin ion-no-padding">
    <ion-item button [disabled]="!hasGrantToWriteMachine" id="open-modal" expand="block">{{'ADAPTER.ASSIGN' | translate}}</ion-item>
    <ion-item button [disabled]="!hasGrantToWriteMachine" (click)="onClickEdit()">{{'EDIT' | translate}}</ion-item>
    <ion-item button [disabled]="!hasGrantToWriteMachine" *ngIf="!machineDto.active"  (click)="onClickActivate()">{{'ACTIVATE' | translate}}</ion-item>
    <ion-item button [disabled]="!hasGrantToWriteMachine" *ngIf="machineDto.active"  (click)="onClickDeactivate()">{{'DEACTIVATE' | translate}}</ion-item>
    <ion-item button [disabled]="!hasGrantToWriteMachine" *ngIf="!machineDto.deleted" (click)="onClickDelete()">{{'DELETE' | translate}}</ion-item>
  </ion-list>

  <ion-modal 
  [initialBreakpoint]="1"
  [breakpoints]="[0, 1]"
  #modal 
  trigger="open-modal">
      <ng-template>
        <ion-header>
          <ion-toolbar>
            <ion-buttons slot="start">
              <ion-button (click)="modal.dismiss()"><span>{{'CANCEL'|translate}}</span></ion-button>
            </ion-buttons>
            <ion-title>{{'ADAPTER.ASSIGN'|translate}}</ion-title>
          </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
          <ion-searchbar debounce="500" (ionInput)="onSearch($event)"></ion-searchbar>
          <ion-list>
            <ion-item *ngFor="let adapter of adapters" (click)="selectAdapter(adapter.mac)">
              <div>
              <p>{{adapter.serial}}</p>
              <p class="machine_name"><span *ngIf="adapter.pairedMachine?.name"> {{adapter.pairedMachine.name}} </span>
              <span *ngIf="adapter.pairedMachine?.make && adapter.pairedMachine?.model && !adapter.pairedMachine?.name"> {{adapter.pairedMachine.make}} {{adapter.pairedMachine.model}} </span>
              </p>
              </div>
            </ion-item>
          </ion-list>
        </ion-content>
      </ng-template>
  </ion-modal>

